import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ redirectPath = "/login" }) => {
  const memberInfoData = useSelector((state) => state.memberInfo.memberInfoData);
  const isLoggedIn = !!memberInfoData; 
  return isLoggedIn ? <Outlet /> : <Navigate to={redirectPath} replace />;
};

export default ProtectedRoute;